import React, { useEffect, useState } from 'react';
import '../Components/Styles/confirmationCommande.css';

function ConfirmationCommande() {
  const queryParams = new URLSearchParams(window.location.search);
  const codeRetour = queryParams.get('code-retour'); 
  const reference = queryParams.get('reference');
  console.log("Paramètres reçus :", Object.fromEntries(queryParams.entries()));
  const [commande, setCommande] = useState(null);

  useEffect(() => {
  if (reference) {
    fetch(`/api/recup_commandes.php?reference=${reference}`)
      .then(res => res.json())
      .then(data => setCommande(data))
      .catch(err => console.error("Erreur récupération commande :", err));
  }
}, [reference]);

  let message;
  let style = {};

  if (codeRetour === 'paiement') {
    message = 'Merci ! Votre paiement a été effectué avec succès.';
    style = { color: 'green' };
  } else if (codeRetour === 'payetest') {
    message = 'Paiement de test réussi.';
    style = { color: 'blue' };
  } else {
    message = "Paiement incomplet.";
    style = { color: 'gray' };
  }

  return (
    <div className="confirmation-container">
      <p className={`confirmation-message ${codeRetour === 'paiement' ? 'success' : codeRetour === 'payetest' ? 'test' : 'failed'}`}>
        {message}
      </p>

      {commande && (
        <div className="confirmation-details">
          <h2>Détails de votre commande</h2>
          <p><strong>Référence :</strong> {commande.reference}</p>
          <p><strong>Nom :</strong> {commande.client.firstName} {commande.client.lastName}</p>
          <p><strong>Email :</strong> {commande.client.email}</p>
      
          <h3>Produits :</h3>
          <ul>
            {commande.cart.map(item => (
              <li key={item.variante_option_id}>
                {item.nom} - Quantité : {item.quantity} - Prix unitaire : {item.price}€
              </li>
            ))}
          </ul>
          
          <p><strong>Frais de livraison :</strong> {commande.deliveryCost.toFixed(2)}€</p>
          <p><strong>Total payé :</strong> {commande.total.toFixed(2)}€</p>
          
          <button onClick={() => window.location.href = '/'}>
            Retour à l'accueil
          </button>
        </div>
      )}
    </div>
  );
}

export default ConfirmationCommande;